import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/bhilwara.jpg";
import Newsletter from "../../shared/Newsletter";
import { Helmet } from "react-helmet";
const Bhilwara = () => {
  return (
    <>
      <Helmet>
        <title>Bhilwara, Rajasthan | The Rustic Paths</title>

        <meta charset="UTF-8" />

        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <meta
          name="description"
          content="Discover the charm of Bhilwara in Rajasthan, India with The Rustic Paths. Immerse yourself in the rich textile heritage, explore the historical landmarks, and experience the cultural vibrancy of Bhilwara. Plan your journey with our private driver services and unravel the unique attractions that make Bhilwara a delightful destination."
        />
        <meta
          name="keywords"
          content="Bhilwara, Rajasthan, private driver, textile heritage, historical landmarks, cultural vibrancy, unique attractions"
        />
        <meta name="author" content="The Rustic Paths" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Bhilwara, Rajasthan - The Rustic Paths"
        />
        <meta
          property="og:description"
          content="Discover the charm of Bhilwara in Rajasthan, India with The Rustic Paths. Immerse yourself in the rich textile heritage, explore the historical landmarks, and experience the cultural vibrancy of Bhilwara. Plan your journey with our private driver services and unravel the unique attractions that make Bhilwara a delightful destination."
        />
        <meta
          property="og:url"
          content="https://therusticpaths.com/destinations/Rajasthan/bhilwara"
        />
        <meta property="og:image" content="URL_to_your_featured_image.jpg" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Bhilwara, Rajasthan - The Rustic Paths"
        />
        <meta
          name="twitter:description"
          content="Discover the charm of Bhilwara in Rajasthan, India with The Rustic Paths. Immerse yourself in the rich textile heritage, explore the historical landmarks, and experience the cultural vibrancy of Bhilwara. Plan your journey with our private driver services and unravel the unique attractions that make Bhilwara a delightful destination."
        />
        <meta name="twitter:image" content="URL_to_your_featured_image.jpg" />

        <link rel="icon" href="path_to_your_favicon.ico" type="image/x-icon" />
      </Helmet>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
          Bhilwara
        </h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Asind</li>
                      <li>Mandal</li>
                      <li>Bijoliya</li>
                      <li>Shahpura</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Bhilwara
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    An industrial city, Bhilwara came to be called so because it
                    had a huge majority of Bhil inhabitants. However, these
                    Bhils were driven away by peasants. Ironically, very few
                    Bhils live in Bhilwara now. There's another story attributed
                    to how the place got its name. Bhilwara reportedly had a
                    mint where coins known as 'Bhiladi' were minted and thus
                    came the name of the city.
                  </p>
                  <p>
                    Renowned in India as the 'Textile City', Bhilwara is home to
                    more than 14,000 small-scale industries. The 900-crore
                    textile industry employs about 35,000 people and is the
                    greatest source of revenue for the city.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Asind
                  </h2>

                  <p>
                    One of Prithvi Raj Chauhan's descendent's son Sawai Bhoj
                    built some temples on the banks of the Khari. Asind itself
                    is the headquarters of a tehsil and Panchayat Samiti.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Mandal
                  </h2>
                  <p>
                    Situated at a distance of 13 kilometers from Bhilwara,
                    Mandal houses a village called Meza where an irrigation dam
                    has been constructed on river Kothari. The dam site has
                    boating facilities and a picturesque lake for company. These
                    make for beautiful tourist destinations. A Neelkanth Mahadev
                    Temple here is also one of the must-see places.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bijoliya
                  </h2>
                  <p>
                    Walled with two gates on the north and south, Bijoliya is
                    situated on a plateau called Uparmal and makes for a
                    beautiful sight. The place has five Jain temples dedicated
                    to Parsvanath. Then, there's a reservoir called the
                    Mandakini Baori.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Shahpura
                  </h2>
                  <p>
                    A sacred place for followers of the 'Ram Sanehis'. The Ram
                    Dwara here draws huge number of visitors every year. The
                    annual 'Phool Dol Ka Mela' is held here on Phagun Shukla for
                    five days. Lakhs of tourists come here for the same.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Bhilwara;
